import { Link } from "react-router-dom";

export default function Logo({ className = "", onClick }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      className={`inline-flex items-center ${className}`}
      data-testid="logo-home-link"
      aria-label="Ashlar Buildchem home"
    >
      <img
        src="/logo-dark.png"
        alt="Ashlar Buildchem"
        className="h-8 w-auto md:h-9"
        draggable="false"
      />
    </Link>
  );
}
